import style from "./Logo.module.css";
import { useDataManagement } from '../ferramentas/RequisitarAPI.ts';
import { useEffect, useState } from "react";
import { ReactComponent as CircuitLoader } from '../../img/loaders/circuit-board.svg';


const Logo = ({ layout = "default" }) => {
    const classname = {
        "dashboard": style.dashboard,
        "login": style.login,
        "default": style.logo,
    }

    const { customization } = useDataManagement();

    const [logo, setLogo] = useState(null);
    const [isImageLoaded, setIsImageLoaded] = useState(false);

    useEffect(() => {
        const fetchCustomization = async () => {
            try {
                const response = await customization.logo_primary();
                if (response.ok && response.data?.logo) {
                    setLogo(response.data.logo);
                } else {
                    setLogo('/img/logo1');
                }
            } catch (error) {
                console.error("Failed to fetch logo:", error);
                setLogo('/img/logo1');
            }
        };
        fetchCustomization();
    }, [customization]);

    return (
        <div className={classname[layout]}>
            {!isImageLoaded && <CircuitLoader />}
            {logo && (
                <img
                    className={style.img_logo}
                    src={logo}
                    alt="logo"
                    onLoad={() => setIsImageLoaded(true)}
                    onClick={() => window.location.href = "/"}
                    style={{ display: isImageLoaded ? 'block' : 'none' }}
                />
            )}
        </div>
    );
};

export default Logo;